module.exports = __webpack_public_path__ + "static/media/unchecked.4afab43c.svg";